import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowDownSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.293 12.292.708-.706L18.414 13l-.707.706-5.006 5-.707.707-.707-.707-4.994-5-.707-.708L7 11.586l.707.707L11 15.59V4.21h2v11.372l3.293-3.29Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowDownSharp);
export default Memo;
